/* eslint-disable @khan/frontend/require-stories -- TODO */
import * as React from "react";

// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import type {PropsFor} from "@khanacademy/wonder-blocks-core";

import {perseusStrings} from "../perseus-strings-lingui.tsx";

import {PerseusI18nProviderWrapper} from "./perseus-i18n-provider-wrapper.tsx";

interface Props extends Omit<PropsFor<typeof Perseus.Renderer>, "strings"> {
    dependencies: Perseus.PerseusDependenciesV2;
}

export const Renderer = React.forwardRef<Perseus.Renderer, Props>(
    (props: Props, ref) => (
        <PerseusI18nProviderWrapper>
            <Perseus.DependenciesContext.Provider value={props.dependencies}>
                <Perseus.Renderer
                    {...props}
                    strings={perseusStrings()}
                    ref={ref}
                />
            </Perseus.DependenciesContext.Provider>
        </PerseusI18nProviderWrapper>
    ),
);
